import '../../components/storename-autogen-signup-smart-field';

const CALCULATOR_FORM_KEYS = {
  inflow: ['instore_sales', 'online_sales', 'inflow_other'],
  outflow: [
    'rent',
    'payroll',
    'inventory_costs',
    'utilities',
    'equipment',
    'marketing',
    'taxes',
    'insurance',
    'interest',
    'fees',
    'outflow_other',
  ],
};

function initCalculator() {
  const form = document.querySelector('.capital-calculator__form');
  const {hreflang} = form.dataset;
  const formKeys = [...CALCULATOR_FORM_KEYS.inflow, ...CALCULATOR_FORM_KEYS.outflow];

  formKeys.map(
    (key) => document.querySelector(`input[name="${key}"]`)
      .addEventListener('change', (event) => calculateTotals(event, hreflang)),
  );
  form.querySelector('.capital-calculator__button')
    .addEventListener('click', (event) => calculateResult(event, hreflang));
}

function calculateTotals(event, hreflang) {
  event.preventDefault();
  const inflowTotalNode = document.getElementById('inflow_total');
  const outflowTotalNode = document.getElementById('outflow_total');
  const inflowValues = CALCULATOR_FORM_KEYS.inflow.map(
    (key) => Number(document.querySelector(`input[name="${key}"]`).value) || 0,
  );
  const outflowValues = CALCULATOR_FORM_KEYS.outflow.map(
    (key) => Number(document.querySelector(`input[name="${key}"]`).value) || 0,
  );

  const inflowTotal = inflowValues.reduce((val1, val2) => val1 + val2, 0);
  const outflowTotal = outflowValues.reduce((val1, val2) => val1 + val2, 0);
  inflowTotalNode.textContent = currencyFormat(inflowTotal, hreflang);
  outflowTotalNode.textContent = currencyFormat(outflowTotal, hreflang);

  return {inflowTotal, outflowTotal};
}

function calculateResult(event, hreflang) {
  event.preventDefault();
  const {inflowTotal, outflowTotal} = calculateTotals(event, hreflang);
  setResults(inflowTotal, outflowTotal, hreflang);
}

function setResults(inflowTotal, outflowTotal, hreflang) {
  hidePreviousResult();
  const greetingImage = document.getElementById('cashflow_calculator_image');
  const resultNode = document.querySelector('.capital-calculator__result-wrapper');
  const monthlyInflowNode = document.getElementById('result-monthly-inflow');
  const monthlyOutflowNode = document.getElementById('result-monthly-outflow');
  const netcashOutflowNode = document.getElementById('result-net-cash-flow');

  greetingImage.style.display = 'none';
  resultNode.style.display = 'block';
  monthlyInflowNode.textContent = currencyFormat(inflowTotal, hreflang);
  monthlyOutflowNode.textContent = currencyFormat(outflowTotal, hreflang);
  netcashOutflowNode.textContent = currencyFormat(inflowTotal - outflowTotal, hreflang);

  if (inflowTotal >= outflowTotal) {
    document.getElementById('positive_result_heading').style.display = 'block';
    document.getElementById('result-cashflow-positive').style.display = 'block';
  } else {
    document.getElementById('negative_result_heading').style.display = 'block';
    document.getElementById('result-cashflow-negative').style.display = 'block';
  }
}

function hidePreviousResult() {
  document.getElementById('positive_result_heading').style.display = 'none';
  document.getElementById('negative_result_heading').style.display = 'none';
  document.getElementById('result-cashflow-positive').style.display = 'none';
  document.getElementById('result-cashflow-negative').style.display = 'none';
}

function currencyFormat(value, hreflang) {
  return new Intl.NumberFormat(hreflang, {
    style: 'currency',
    currency: currencyByLang(hreflang),
  })
    .format(value);
}

function currencyByLang(hreflang) {
  switch (hreflang) {
    case 'en-GB':
      return 'GBP';
    case 'en-AU':
      return 'AUD';
    case 'en-CA' || 'fr-CA':
      return 'CAD';
    default:
      return 'USD';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCalculator);
} else {
  initCalculator();
}
